export default __webpack_public_path__ + "static/media/UploadVideos.214b83f6.svg";